import React from 'react';

const AccessIcon = (props) => {
  const { width = 21, height = 14, className } = props;

  return (
   <svg  className={className} width={width} height={height}xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 14" fill="none">
  <g clipPath="url(#clip0_4909_452)">
    <path d="M7.57966 3.64577C6.45966 4.80577 3.65966 7.66577 1.08966 10.4658L0.849657 10.7258L0.679657 10.9658C0.429657 11.3558 0.529657 11.4858 0.799657 11.8458C1.20966 12.4058 1.11966 12.3258 1.70966 12.7058C1.93966 12.8558 2.22966 12.9358 2.49966 12.8758C2.77966 12.8058 2.86966 12.7558 3.06966 12.5558C3.26966 12.3458 5.56966 9.98577 9.99966 5.88577C9.99966 5.88577 12.3297 3.82577 13.6997 6.06577C15.9697 9.80577 16.5797 11.9058 17.4397 13.5358C17.5897 13.8158 17.7697 13.9258 17.8597 13.9258C18.0497 13.9558 18.4297 13.9858 18.7497 13.8858C19.5497 13.6158 19.9197 13.0258 20.5597 12.4858C20.9697 12.1358 21.1497 12.0258 20.8797 11.5558C19.5697 9.18577 16.8997 4.01577 16.3997 3.13577C14.2497 -0.654233 9.94966 1.20577 7.58966 3.65577L7.57966 3.64577Z" fill="currentcolor"/>
  </g>
  <defs>
    <clipPath id="clip0_4909_452">
      <rect width="12.99" height="20.46" fill="currentcolor" transform="matrix(0 -1 1 0 0.540039 13.9565)"/>
    </clipPath>
  </defs>
</svg>
  );
};

export default AccessIcon;
